// import React from 'react';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../assets/css/style.css';
import '../assets/css/style.css.map';
import '../assets/css/slick.min.css';
import patwedges from "../assets/img/update_2/normal/patwedges.png";
import pattyburger11 from "../assests/img/ProductsImages/PotatoBurgerPatty1.jpg";
import hashbrown1 from "../assets/img/update_2/normal/hashbrown1.jpg";
import hashbrown12 from "../assests/img/ProductsImages//HashBrown.jpg";
import herbchillyburgerpatty from "../assests/img/ProductsImages/HerbandChilliBurgerPatty.jpg";
import alootikki from "../assets/img/update_2/normal/alootikki01.png";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import potatoban1 from "../assets/img/potatoban1.png";
import header_terms from "../assets/img/header_terms.png";

import Footer from './footer';

const TermsandCondition = () => {
    // const location = useLocation();

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    // }, [location]);
    const settingsscroll = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        appendDots: dots => (
            <ul style={{ display: 'flex', justifyContent: 'center', margin: '20px 0' }}>
                {dots.map((dot, index) => (
                    <li key={index} style={{ listStyle: 'none', margin: '0 10px' }}>
                        <div
                            style={{
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                background: index === dot.props.current ? '#ff0000' : '#fff', // Red for active dot, white for others
                                border: '0px solid #333', // Customize the border color
                                cursor: 'pointer',
                                marginTop: '20px',
                            }}
                        />
                    </li>
                ))}
            </ul>
        )
    };
    return (
        <div>
            {/* <div className="breadcumb-wrapper" style={{ backgroundImage: `url(${breadcumb_bg_2})` }}>
                <div class="container z-index-common">
                    <div class="breadcumb-content">
                        <h1 class="breadcumb-title">Products</h1>
                        <ul class="breadcumb-menu">
                            <li><Link to="/Idgnew/home">Home</Link></li>
                            <li>Products</li>
                        </ul>
                    </div>
                </div>
            </div> */}
            <div classNameName="d-none d-md-block">
                <div id="slider" classNameName="ls-wp-container fitvidsignore hero-6 th-hero-carousel"
                    style={{ margin: '0 auto' }}>
                    <div classNameName="ls-slide" data-ls="duration:5000; kenburnsscale:1.2;">
                        <div className="infrastructure-name">
                            <div style={{ marginTop: "-40px" }}>
                                <ul style={{ listStyleType: 'none', padding: 20 }}>
                                    <li><h1 style={{ color: 'white', margin: 0, padding: 0 ,fontFamily:'helvetica',color:'white'}}>TERMS & CONDITION</h1></li>
                                    <li>
                                        <Link to="/home" style={{ color: 'white', padding: 4 }}><span className="homeclass" style={{ fontFamily:'helvetica' }}>Home</span> &nbsp;</Link>
                                        <span style={{ color: 'white' }}>&gt; &nbsp;<span className="redname" style={{ fontFamily:'helvetica',color:'#F0B323',color: '#0f1138'}}>Terms & Condition</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <img
                            width="2000"
                            height=""
                            src={header_terms}
                            className="ls-l ls-img-layer factory"
                            alt="image"
                            decoding="async"
                            style={{
                                fontSize: '36px',
                                height: "",
                                color: '#000',
                                stroke: '#000',
                                strokeWidth: '0px',
                                textAlign: 'right',
                                fontStyle: 'normal',
                                textDecoration: 'none',
                                textTransform: 'none',
                                fontWeight: '400',
                                letterSpacing: '0px',
                                backgroundPosition: '0% 0%',
                                backgroundRepeat: 'no-repeat',
                                backgroundClip: 'border-box',
                                overflow: 'visible',
                                left: '0px',
                                top: '107px',
                                WebkitBackgroundClip: 'border-box'
                            }}
                            data-ls="offsetxin:500; durationin:600; delayin:100; easingin:easeOutBack; rotatein:80; bgcolorin:transparent; colorin:transparent;"
                        />
                    </div>
                </div>
            </div>



            <div className="about-sec overflow-hidden my-5 pb-5" >
                <div className="container">
                    <p>Welcome to <b>YUMWAY</b>. These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to comply with and be bound by the following terms.</p>

                    <h5>1. Acceptance of Terms</h5>
                    <p>By using our services, you confirm that you are at least 18 years of age and legally capable of entering into contracts. Continued use of our website and services constitutes acceptance of these terms.</p>

                    <h5>2. Description of Services</h5>
                    <p>Yumway is a trusted global exporter of premium frozen foods, specializing in processed snacks and ready-to-eat frozen meals. From production to international delivery, we ensure products meet strict standards of quality, taste, and freshness.</p>

                    <h5>3. User Responsibilities</h5>
                    <ul>
                        <li>Provide accurate and complete information when engaging with Yumway.</li>
                        <li>Use our website and services only for lawful purposes.</li>
                        <li>Refrain from misusing or interfering with the functionality of our website, systems, or content.</li>
                    </ul> 

                    <h5>4. Intellectual Property</h5>
                    <p>All content, features, trademarks, graphics, and packaging designs associated with Yumway are the intellectual property of Yumway and may not be copied, reproduced, or reused without prior written consent.</p>

                    <h5>5. Payment Terms</h5>
                    <p>For business transactions, all payments must be made in accordance with the pricing, billing terms, and agreements provided at the time of order confirmation. Unless otherwise stated, all payments are non-refundable.</p>


                    <h5>6. Product Quality & Liability</h5>
                    <p>While Yumway ensures that every product meets the highest safety and quality standards, we are not liable for indirect, incidental, or consequential damages arising from improper storage, handling, or misuse of products after delivery.</p>
  
                    <h5>7. International Shipping & Compliance</h5>
                    <p>All shipments are subject to applicable export/import regulations. Customers are responsible for ensuring compliance with their country’s food safety and import policies.</p>

                    <h5>8. Termination of Services</h5>
                    <p>We reserve the right to suspend or terminate access to our services if these Terms are violated or if the platform is misused in a harmful or unlawful way.</p>

                    <h5>9. Changes to Terms</h5>
                    <p>Yumway reserves the right to update or change these Terms at any time without prior notice. We recommend reviewing this page periodically. Continued use of the service after changes implies acceptance.</p>   

                    <h5>10. Governing Law</h5>
                    <p>These Terms shall be governed by and interpreted in accordance with the laws of India, without regard to conflict of law provisions.</p>  

                    <h5>11. Contact Us</h5>
                    <p>For questions regarding these Terms and Conditions, please contact us at: <br/>
                        <b>Email:</b> support@icedreamglobal.com</p>                                                                                                                                                                           

                        
                </div>
            </div>            

            <br />
            <Footer />
        </div>
    );
};

export default TermsandCondition;
